module.exports = __webpack_public_path__ + "static/media/edit-icon.svg.ba469a1e.svg";